import { ExtendedAction } from '@config/reduxStore';
import { ProcessoEmpreendimento } from '@models/ProcessoEmpreendimento';

interface LegalizacaoReducer {
  items: ProcessoEmpreendimento[];
  loading: boolean;
  legalizacaosaving: boolean;
  feedback: string;
}
var initialState: LegalizacaoReducer = {
  items: [],
  loading: false,
  legalizacaosaving: false,
  feedback: '',
};

const legalizacaoReducer = function (state = initialState, action: ExtendedAction) {
  switch (action.type) {
    case 'CHANGE_PROGRESSO_LEGALIZACAO_CLIENTE_PENDING':
      state = {
        ...state,
        loading: true,
        feedback: '',
      };
      break;
    case 'CHANGE_PROGRESSO_LEGALIZACAO_CLIENTE_REJECTED':
      state = {
        ...state,
        loading: false,
        feedback: action.payload.response.data.Message,
      };
      break;
    case 'CHANGE_PROGRESSO_LEGALIZACAO_CLIENTE_FULFILLED':
      state = {
        ...state,
        loading: false,
        items: state.items.map((c) => {
          if (c.id === action.payload.data.processoid) {
            c.progresso = action.payload.data.progresso;
            return c;
          } else {
            return c;
          }
        }),
      };
      break;
    case 'CHANGE_ORDER_LEGALIZACAO_PENDING':
      state = {
        ...state,
        loading: true,
        feedback: '',
      };
      break;
    case 'CHANGE_ORDER_LEGALIZACAO_REJECTED':
      state = {
        ...state,
        loading: false,
        feedback: action.payload.response.data.Message,
      };
      break;
    case 'CHANGE_ORDER_LEGALIZACAO_FULFILLED':
      state = {
        ...state,
        loading: false,
        items: action.payload.data,
      };
      break;
    case 'DELETE_LEGALIZACAO_PENDING':
      state = {
        ...state,
        loading: true,
        feedback: '',
      };
      break;
    case 'DELETE_LEGALIZACAO_REJECTED':
      state = {
        ...state,
        loading: false,
        feedback: action.payload.response.data.Message,
      };
      break;
    case 'DELETE_LEGALIZACAO_FULFILLED':
      state = {
        ...state,
        loading: false,
        items: [...state.items.filter((c) => c.id !== action.payload.data)],
      };
      break;
    case 'ADD_LEGALIZACAO_PENDING':
      state = {
        ...state,
        legalizacaosaving: true,
        feedback: '',
      };
      break;
    case 'ADD_LEGALIZACAO_REJECTED':
      state = {
        ...state,
        legalizacaosaving: false,
        feedback: action.payload.response.data.Message,
      };
      break;
    case 'ADD_LEGALIZACAO_FULFILLED':
      state = {
        ...state,
        legalizacaosaving: false,
        items: [...state.items, action.payload.data],
      };
      break;
    case 'GET_LEGALIZACAO_PENDING':
      state = {
        ...state,
        loading: true,
        feedback: '',
      };
      break;
    case 'GET_LEGALIZACAO_REJECTED':
      state = {
        ...state,
        loading: false,
        feedback: action.payload.response.data.Message,
      };
      break;
    case 'GET_LEGALIZACAO_FULFILLED':
      state = {
        ...state,
        loading: false,
        items: action.payload.data,
      };
      break;
    default:
      return state;
  }
  return state;
};

export default legalizacaoReducer;
